import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DataService from 'lib/DataService';

import Loading from '../Loading';
import Editor from './Editor';

import EditorContext from 'contexts/Editor';

const Api = new DataService();

class Brochure extends Component {
	static propTypes = {
	  match: PropTypes.object,
	  activeSlot: PropTypes.any,
	  pageListOpen: PropTypes.bool,
	  controlsOpen: PropTypes.bool,
	  generatePDFOpen: PropTypes.bool,
	  brochure: PropTypes.object,
	  buildings: PropTypes.array,
	  pictograms: PropTypes.array,
	  config: PropTypes.object,
	  updateBrochureHandler: PropTypes.func,
	  updateBuildingHandler: PropTypes.func,
	  toggleBrochurePageListHandler: PropTypes.func,
	  togglePageListHandler: PropTypes.func,
	  toggleControlsHandler: PropTypes.func,
	  toggleGeneratePdfOpen: PropTypes.func,
	  activeSlotHandler: PropTypes.func,
	}

	constructor(props) {
	  super(props);

	  this.props.togglePageListHandler(false);
	  this.props.toggleControlsHandler(false);
	  this.props.activeSlotHandler(null);

	  this.state = {
	    loading: true,
	  }
	}

	activeSlotHandler = activeSlot => {
	  this.props.toggleControlsHandler(activeSlot !== null);

	  this.props.activeSlotHandler(activeSlot);
	};

	newPageHandler = ({ loading }) => this.setState(state => {
	  this.props.togglePageListHandler(false);
	  this.props.toggleControlsHandler(true);
	  this.props.activeSlotHandler(null);

	  return {
	    loading,
	  }
	});

	updatePageDataHandler = ({ pageId, pageContent }) => {
	  const { brochure } = JSON.parse(JSON.stringify(this.props));
	  const pageInContent = typeof brochure.content.pages.find(page => page.id === pageId) !== 'undefined';

	  if (pageInContent) {
	    brochure.content.pages = brochure.content.pages.map(page => (
	      {
	        ...page,
	        ...(page.id === pageId ? pageContent : {})
	      }
	    ));
	  } else {
	    brochure.content.pages.push(pageContent);
	  }

	  this.props.updateBrochureHandler(brochure);
	}

	updateContentHandler = content => {
	  const { brochure } = JSON.parse(JSON.stringify(this.props));

	  brochure.content = content;

	  this.props.updateBrochureHandler(brochure);
	}

	// Just to instantly update the state before we've received the new content from server
	movePageHandler = ({ pageFrom, pageTo }) => {
	  const { brochure } = JSON.parse(JSON.stringify(this.props));

	  const page = brochure.content.pages.splice(pageFrom, 1)[0];

	  brochure.content.pages.splice(pageTo, 0, page);

	  this.props.updateBrochureHandler(brochure);
	}

	removePageDataHandler = pageId => {
	  const { brochure } = JSON.parse(JSON.stringify(this.props));
	  const brochureId = brochure.id;
	  const pageIndex = brochure.content.pages.findIndex(page => page.id === pageId);

	  if (pageIndex !== -1) {
	    brochure.content.pages.splice(pageIndex, 1);

	    this.setState({ loading: true });

	    Api.deletePage({ brochureId, pageId })
	      .then(res => {
	        this.props.updateBrochureHandler(brochure);
	        this.setState({ loading: false });
	      });
	  }
	}

	togglePageListHandler = () => {
	  this.props.togglePageListHandler();
	  this.props.activeSlotHandler(null);
	};

	toggleControlsHandler = () => {
	  this.props.activeSlotHandler(null);
	  this.props.toggleControlsHandler();
	};

	togglePageSettingsHandler = () => {
	  let { activeSlot, controlsOpen } = this.props;

	  controlsOpen = controlsOpen ?
	    activeSlot === null ? false : true : true;

	  this.props.toggleControlsHandler(controlsOpen);
	  this.props.activeSlotHandler(null);
	};

	componentDidMount() {
	  console.log('[Brochure.js] componentDidMount');

	  const {
	    match: {
	      params: {
	        brochureId
	      }
	    }
	  } = this.props;

	  this.mounted = true;

	  // Get full brochure data
	  Api.getBrochure(brochureId)
	    .then(response => {
	      if (this.mounted) {
	        const brochure = response.result.brochure[0];

	        Api.getBuilding(brochure.building)
	          .then(building => {

	            building.fullData = true;
	            //delete building.spaces;

	            this.props.updateBuildingHandler(building);
	            this.props.updateBrochureHandler(brochure);

	            this.setState(state => ({
	              loading: false
	            }))
	          });

	        // Show page list if we're still mounted and brochure doesn't have any pages
	        if (this.mounted && brochure.content.pages.length === 0) {
	          this.props.togglePageListHandler(true);
	        }
	      }
	    });
	}

	componentWillUnmount() {
	  console.log('[Brochure.js] componentWillUnmount');
	  this.mounted = false;
	  this.props.updateBrochureHandler(null);
	}

	render() {
	  if (this.state.loading) {
	    return <Loading />
	  }

	  const building = this.props.buildings.find(building => building.slug === this.props.brochure.building);

	  return (
	    <EditorContext.Provider value={{
	      activeSlot: this.props.activeSlot,
	      pageListOpen: this.props.pageListOpen,
	      controlsOpen: this.props.controlsOpen,
	      togglePageListHandler: this.togglePageListHandler,
	      toggleControlsHandler: this.toggleControlsHandler,
	      activeSlotHandler: this.activeSlotHandler,
	      updatePageDataHandler: this.updatePageDataHandler,
	      updateContentHandler: this.updateContentHandler,
	      movePageHandler: this.movePageHandler,
	    }}>
	      <Editor
	        activeSlot={this.props.activeSlot}
	        brochure={this.props.brochure}
	        building={building}
	        pictograms={this.props.pictograms}
	        generatePDFOpen={this.props.generatePDFOpen}
	        config={this.props.config}
	        updatePageDataHandler={this.updatePageDataHandler}
	        removePageDataHandler={this.removePageDataHandler}
	        toggleGeneratePdfOpen={this.props.toggleGeneratePdfOpen}
	        newPageHandler={this.newPageHandler}
	        activeSlotHandler={this.activeSlotHandler}
	      />
	    </EditorContext.Provider>
	  )
	}
}

export default Brochure
